export const validateEmail = (email) => {
  const atIndex = email.indexOf("@");
  const dotIndex = email.indexOf(".", atIndex);
  return atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < email.length - 1;
};

export const validatePassword = (password) => {
  return password.length >= 8;
};
